import type { CardRecord } from "@/lib/types";

/** Lien recherche Cardmarket (Riftbound). */
export function cardmarketSearchUrl(card: Pick<CardRecord, "name" | "setId" | "collectorNumber">): string {
  const parts = [card.name];
  if (card.setId && card.collectorNumber != null) {
    parts.push(`${card.setId} ${card.collectorNumber}`);
  }
  const q = encodeURIComponent(parts.join(" ").trim());
  return `https://www.cardmarket.com/en/Riftbound/Products/Search?searchString=${q}`;
}

/** Lien recherche CardNexus (Riftbound). */
export function cardnexusSearchUrl(card: Pick<CardRecord, "name" | "setId" | "collectorNumber">): string {
  const query =
    card.setId && card.collectorNumber != null
      ? `${card.setId}-${card.collectorNumber}`
      : card.name;
  return `https://app.cardnexus.com/en/search?game=riftbound&q=${encodeURIComponent(query)}`;
}

export type MerchantLink = {
  id: "cardmarket" | "cardnexus";
  label: string;
  href: string;
};

export function merchantLinksForCard(
  card: Pick<CardRecord, "name" | "setId" | "collectorNumber">,
): MerchantLink[] {
  return [
    { id: "cardmarket", label: "Cardmarket", href: cardmarketSearchUrl(card) },
    { id: "cardnexus", label: "CardNexus", href: cardnexusSearchUrl(card) },
  ];
}
